module.exports = __webpack_public_path__ + "img/partner24.67a28c14.png";